// frontend/src/components/AppMenu.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle, faHeart } from '@fortawesome/free-solid-svg-icons';
import { useSwipeable } from 'react-swipeable';
import './AppMenu.css';
import modules from './IconGridData';

const AppMenu = () => {
    const [index, setIndex] = useState(0);
    
    const handleSwipe = (delta) => {
        const newIndex = index + delta;
        if (newIndex >= 0 && newIndex < chunkedModules.length) {
            setIndex(newIndex);
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => handleSwipe(1),
        onSwipedRight: () => handleSwipe(-1),
    });

    const chunkedModules = [];
    for (let i = 0; i < modules.length; i += 15) {
        chunkedModules.push(modules.slice(i, i + 15));
    }

    return (
        <div className="app-menu ml-14 mt-8" {...handlers}>
            {chunkedModules.map((chunk, chunkIndex) => (
                <div key={chunkIndex} className={`menu-container ${chunkIndex === index ? 'active' : ''}`}>
                    <div className="menu-grid">
                        {chunk.map((module, moduleIndex) => (
                            <div key={moduleIndex} className="menu-item">
                                {module.isActive ? (
                                    <>
                                    <Link to={module.landingPageUrl} className="menu-link">
                                        <div className="menu-item">
                                            <div className="icon-circle">
                                                <FontAwesomeIcon icon={module.icon} />
                                            </div>
                                            <span className="menu-title">{module.title}</span>
                                        </div>
                                    </Link>
                                    </>
                                ):
                                (
                                    <>
                                    <div className="menu-link-disabled">
                                        <div className="menu-item">
                                            <div className="icon-circle">
                                                <FontAwesomeIcon icon={module.icon} className="icon-disabled" />
                                            </div>
                                            <span className="menu-title text-gray-400">{module.title}</span>
                                        </div>
                                    </div>
                                    </>
                                )
                                }
                            </div>
                        ))}
                    </div>
                </div>
            ))}
            <div className="more-item">
                {[...Array(chunkedModules.length)].map((_, i) => (
                    <FontAwesomeIcon
                        key={i}
                        icon={faDotCircle}
                        className={`menu-icon ${i === index ? 'active' : ''}`}
                        style={{ color: i === index ? 'blue' : 'grey' }}
                    />
                ))}
            </div>
        </div>
    );
};

export default AppMenu;
